import apiClient, { handleApiError } from './apiClient';

export interface DashboardStats {
  totalProductos: number;
  productosStockBajo: number;
  ventasHoy: number;
  totalVentasHoy: number;
  totalClientes: number;
  alertasActivas: number;
  pedidosPendientes: number;
  pedidosHoy: number;
  totalCategorias: number;
  ingresosMes: number;
  productosMasVendidos: Array<{
    producto__nombre: string;
    producto__id: number;
    total_vendido: number;
  }>;
  ventasSemana: Array<{
    fecha: string;
    total: number;
  }>;
}

export interface Producto {
  id: number;
  nombre: string;
  descripcion: string;
  precio: number;
  stock: number;
  categoria: {
    id: number;
    nombre: string;
  } | null;
  imagen: string | null;
  codigo_barras: string;
  activo: boolean;
  stock_minimo: number;
  stock_bajo: boolean;
  total_vendido_mes: number;
  fecha_creacion: string | null;
}

export interface Categoria {
  id: number;
  nombre: string;
  descripcion: string;
  activo: boolean;
  total_productos: number;
  productos_stock_bajo: number;
  fecha_creacion: string | null;
}

export interface Usuario {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  nombre_completo: string;
  rol: 'admin' | 'cliente' | 'repartidor';
  es_admin: boolean;
  es_cliente: boolean;
  es_repartidor: boolean;
  telefono: string;
  direccion: string;
  activo: boolean;
  total_pedidos: number;
  total_ventas: number;
  total_gastado: number;
  fecha_registro: string;
  ultimo_login: string | null;
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await apiClient.get<DashboardStats>('/dashboard/stats/');
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async getProductos(): Promise<Producto[]> {
    try {
      const response = await apiClient.get<Producto[]>('/dashboard/productos/');
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async getCategorias(): Promise<Categoria[]> {
    try {
      const response = await apiClient.get<Categoria[]>('/dashboard/categorias/');
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }

  async getUsuarios(): Promise<Usuario[]> {
    try {
      const response = await apiClient.get<Usuario[]>('/dashboard/usuarios/');
      return response.data;
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
